import React, {FC} from "react";
import {Form, Input} from "antd";
import {optionalLinkedInUrlRules, requiredEmailRules, requiredPhoneRules, requiredTextRules} from "./formRules";
import {useRegistrationCopy} from "./registrationCopy";

// Basic participant details, bound at the form root (single) or under a bulk row.
export const ParticipantFields: FC<{namePrefix?: Array<string | number>}> = ({namePrefix = []}) => {
    const {labels} = useRegistrationCopy();
    const name = (field: string) => namePrefix.length > 0 ? [...namePrefix, field] : field;

    return (
        <>
            <div className="public-registration-form-grid public-registration-form-grid--compact">
                <Form.Item name={name("firstName")} label={labels.firstName} rules={requiredTextRules(labels)}>
                    <Input/>
                </Form.Item>
                <Form.Item name={name("lastName")} label={labels.lastName} rules={requiredTextRules(labels)}>
                    <Input/>
                </Form.Item>
                <Form.Item name={name("email")} label={labels.email} rules={requiredEmailRules(labels)}>
                    <Input type="email"/>
                </Form.Item>
                <Form.Item name={name("phoneNumber")} label={labels.phoneNumber} rules={requiredPhoneRules(labels)}>
                    <Input type="tel"/>
                </Form.Item>
                <Form.Item name={name("company")} label={labels.company} rules={requiredTextRules(labels)}>
                    <Input/>
                </Form.Item>
            </div>

            <Form.Item name={name("linkedInUrl")} label={labels.linkedInUrl} rules={optionalLinkedInUrlRules(labels)}>
                <Input type="url"/>
            </Form.Item>
        </>
    );
};
